<template lang="pug" src="./roleEditor.pug"></template>
<style lang="scss" src="./roleEditor.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex'

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import ItemsSlitter from '@/components/ItemsSplitter'

export default {
    components: {
        'v-splitter': ItemsSlitter
    },
    mixins: [validate, validationMixin],
    data: () => ({
        role: {
            name: null,
            enabled: true,
            permissions: [],
            categories: []
        },
        availableCategories: [],
        availablePermissions: [],
        canSaveChanges: false,
        shownItems: 'permissions'
    }),
    validations: {
        role: {
            name: {
                required
            }
        }
    },
    computed: {
        ...mapGetters(['type']),
        ...mapState({
            roles: state => state.roles.rolesList,
            permissions: state => state.roles.permissions,
            categories: state => state.sqlReports.categoriesList
        }),
        isEditingMode() {
            return !!this.$route.params.id
        },
        saveText() {
            return this.isEditingMode ? 'update' : 'create'
        },
        saveAction() {
            return this.isEditingMode ? 'updateRole' : 'createRole'
        }
    },
    watch: {
        role: {
            handler() {
                this.canSaveChanges = true
            },
            deep: true
        }
    },
    created() {
        this.loadData()
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/roles/editor') {
            this.role = Object.assign({}, {
                name: null,
                enabled: true,
                permissions: [],
                categories: []
            })

            this.availablePermissions = [...this.permissions]
            this.availableCategories = [...this.categories]
        }

        next()
    },
    methods: {
        async saveChanges() {
            if (this.$v.role.$invalid) {
                this.$v.role.$touch()
                return
            }

            await this.$store.dispatch(`roles/${this.saveAction}`, Object.assign({}, {
                ...this.role,
                permissions: this.role.permissions.map('id'),
                categories: this.role.categories.map('id')
            })).then(res => {
                if (res.status === 200 && res.data) {
                    this.processResponseData(res.data)
                }
            })
        },
        async loadData() {
            if (this.isEditingMode) {
                const roleId = this.$route.params.id

                await this.$store.dispatch('roles/getRoleById', roleId).then(res => {
                    if (res.status === 200 && res.data) {
                        this.processResponseData(res.data)
                    }
                })
            }

            await this.$store.dispatch('roles/getPermissions').then(() => {
                const permissionsIds = this.role.permissions.map('id')
                this.availablePermissions = this.permissions.filter(it => !permissionsIds.includes(it.id))
            })

            await this.$store.dispatch('sqlReports/getReportsCategories', true).then(() => {
                const categoriesIds = this.role.categories.map('id')
                this.availableCategories = this.categories.filter(it => !categoriesIds.includes(it.id))
            })
        },
        processResponseData(data) {
            this.role = Object.assign({}, Object.select(data, [
                'id', ...Object.keys(this.role)
            ]))

            if (this.role.id && !this.isEditingMode) {
                this.$router.push(`/roles/editor/${this.role.id}`)
            }

            this.$nextTick(() => {
                this.canSaveChanges = false
                this.$v.role.$reset()
            })
        }
    }
}
</script>
